import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {LinksComponent} from '../links.component'
//Services
import {LinkService} from 'src/app/core/services/parameters/link.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearLinkModal implements OnInit {

  newLinkForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();

  constructor(
    public dialogRef: MatDialogRef<LinksComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private linkService: LinkService
  ) {
  }

  ngOnInit(): void {
    this.newLinkForm = this.fb.group({
      name: [, Validators.required],
      link: [, Validators.required]
    })
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newLinkForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newLinkForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        id: null,
        name: form.value.name,
        link: form.value.link
      }
      this.linkService.createLink(data).subscribe(_res => {
        this.alert.setNotice('Link creado correctamente', 'success');
            this.showAlert = true;
            this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo crear el link', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
